import React from 'react'
import { useGlobalState } from 'state'
import { IDs } from 'common/consts'
import { HazardMaps } from 'common/hazardmaps'
import { Legend } from 'common/types'

export const HazardMapLayer = () => {
  const state = useGlobalState()
  const hazardMapIds = React.useMemo(() => state.app.hazardMapIds, [state.app.hazardMapIds])

  React.useEffect(() => {
    if (!state.mapbox) return
    state.app.setHazardMapIds(['shinsuishin', 'kaokutoukai_kagan'])
  }, [state.mapbox])

  React.useEffect(() => {
    load()

    const legends: Legend[] = []
    const targets = HazardMaps.filter(h => hazardMapIds.includes(h.id))
    targets.forEach(h => {
      h.legends.forEach(l => {
        if (legends.find(ll => ll.title === l.title) === undefined) {
          legends.push(l)
        }
      })
    })
    state.app.setHazardMapLegends(legends)

    state.mapbox?.on('styleimagemissing', () => {
      // console.error(e)
      // console.log('A error event occurred.')
    })

    state.mapbox?.on('style.load', load)
    return () => {
      state.mapbox?.off('style.load', load)
    }

  }, [hazardMapIds])

  const load = () => {
    HazardMaps.forEach(hazardMap => {
      hazardMap.urls.forEach((url, index) => {
        const sourceId = IDs.hazardMap.source + '-' + hazardMap.id + '-' + index
        const layerId = IDs.hazardMap.layer + '-' + hazardMap.id + '-' + index
        if (hazardMapIds.includes(hazardMap.id)) {
          if (state.map.hasSource(sourceId)) return
          state.map.addSource(sourceId, {
            type: 'raster',
            tiles: [url],
            tileSize: 256,
          })
          state.map.addLayer({
            'id': layerId,
            'type': 'raster',
            'source': sourceId,
            minzoom: 7,
            'paint': {
              'raster-opacity': 0.4
            }
          })
        } else {
          state.map.removeLayer(layerId)
          state.map.removeSource(sourceId)
        }
      })
    })
  }

  return <></>
}
